import React, { useState, useEffect } from 'react';
import api from '../../services/api';

// Modal para editar un grupo de opciones: nombre, descripción, mín/máx,
// y agregar/editar/quitar opciones individuales (ej: quitar "Con leche de soya").
const EditModifierModal = ({ modifier, onClose, onSaved }) => {
  const [form, setForm] = useState({
    name: modifier.name || '',
    description: modifier.description || '',
    min_selections: modifier.min_selections ?? 0,
    max_selections: modifier.max_selections ?? 1,
  });
  const [options, setOptions] = useState((modifier.options || []).map(o => ({ ...o })));
  const [newOption, setNewOption] = useState({ name: '', price_adjustment: '0' });
  const [saving, setSaving] = useState(false);

  const saveGroup = async () => {
    setSaving(true);
    try {
      await api.put(`/modifiers/${modifier.id}`, {
        name: form.name,
        description: form.description,
        min_selections: parseInt(form.min_selections) || 0,
        max_selections: parseInt(form.max_selections) || 1,
      });
      await onSaved();
      onClose();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const updateOptionField = (id, field, value) => {
    setOptions(prev => prev.map(o => o.id === id ? { ...o, [field]: value } : o));
  };

  const saveOption = async (option) => {
    try {
      await api.put(`/modifier-options/${option.id}`, {
        name: option.name,
        price_adjustment: parseFloat(option.price_adjustment) || 0,
      });
      await onSaved();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al guardar la opción');
    }
  };

  const deleteOption = async (option) => {
    if (!window.confirm(`¿Quitar la opción "${option.name}"?`)) return;
    try {
      await api.delete(`/modifier-options/${option.id}`);
      setOptions(prev => prev.filter(o => o.id !== option.id));
      await onSaved();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al eliminar la opción');
    }
  };

  const addOption = async () => {
    if (!newOption.name.trim()) return;
    try {
      const res = await api.post(`/modifiers/${modifier.id}/options`, {
        name: newOption.name.trim(),
        price_adjustment: parseFloat(newOption.price_adjustment) || 0,
      });
      setOptions(prev => [...prev, res.data.data]);
      setNewOption({ name: '', price_adjustment: '0' });
      await onSaved();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al agregar la opción');
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.8)', zIndex: 600,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }} onClick={onClose}>
      <div className="card animate-fade-in" style={{ maxWidth: 520, width: '100%', maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ color: '#e2e8f0' }}>✏️ Editar grupo de opciones</h3>
          <button onClick={onClose} style={{ background: '#334155', color: '#e2e8f0', border: 'none', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer' }}>✕</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10, marginBottom: 16 }}>
          <input type="text" placeholder="Nombre" className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <input type="text" placeholder="Descripción" className="input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          <div>
            <label style={{ color: '#94a3b8', fontSize: 11, display: 'block', marginBottom: 4 }}>Mín selecciones</label>
            <input type="number" min="0" className="input" value={form.min_selections} onChange={e => setForm({ ...form, min_selections: e.target.value })} />
          </div>
          <div>
            <label style={{ color: '#94a3b8', fontSize: 11, display: 'block', marginBottom: 4 }}>Máx selecciones</label>
            <input type="number" min="1" className="input" value={form.max_selections} onChange={e => setForm({ ...form, max_selections: e.target.value })} />
          </div>
        </div>
        <button onClick={saveGroup} disabled={saving} className="btn btn-primary" style={{ width: '100%', marginBottom: 20 }}>
          {saving ? 'Guardando...' : '💾 Guardar datos del grupo'}
        </button>

        <h4 style={{ color: '#94a3b8', fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
          Opciones de este grupo
        </h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
          {options.map(opt => (
            <div key={opt.id} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input
                type="text"
                className="input"
                style={{ flex: 1 }}
                value={opt.name}
                onChange={e => updateOptionField(opt.id, 'name', e.target.value)}
              />
              <input
                type="number"
                step="0.01"
                className="input"
                style={{ width: 110 }}
                value={opt.price_adjustment}
                onChange={e => updateOptionField(opt.id, 'price_adjustment', e.target.value)}
              />
              <button onClick={() => saveOption(opt)} style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981', border: 'none', borderRadius: 8, width: 36, height: 36, cursor: 'pointer' }} title="Guardar">💾</button>
              <button onClick={() => deleteOption(opt)} style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: 'none', borderRadius: 8, width: 36, height: 36, cursor: 'pointer' }} title="Quitar opción">🗑️</button>
            </div>
          ))}
          {options.length === 0 && (
            <p style={{ color: '#64748b', fontSize: 13 }}>Este grupo no tiene opciones. Agrega una abajo.</p>
          )}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            type="text"
            placeholder="Nueva opción (ej: Con canela)"
            className="input"
            style={{ flex: 1 }}
            value={newOption.name}
            onChange={e => setNewOption({ ...newOption, name: e.target.value })}
          />
          <input
            type="number"
            step="0.01"
            placeholder="+/- precio"
            className="input"
            style={{ width: 110 }}
            value={newOption.price_adjustment}
            onChange={e => setNewOption({ ...newOption, price_adjustment: e.target.value })}
          />
          <button onClick={addOption} className="btn btn-success" style={{ padding: '0 16px' }}>+ Agregar</button>
        </div>
      </div>
    </div>
  );
};

const ModifiersPage = () => {
  const [modifiers, setModifiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm());
  const [editTarget, setEditTarget] = useState(null);

  function emptyForm() {
    return {
      name: '', description: '', min_selections: 0, max_selections: 1,
      options: [{ name: '', price_adjustment: '0' }],
    };
  }

  useEffect(() => {
    fetchModifiers();
  }, []);

  const fetchModifiers = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/modifiers');
      if (res.data.status) setModifiers(res.data.data || []);
    } catch (err) {
      const msg = err.response?.data?.message;
      setError(msg ? `Error del servidor: ${msg}` : 'No se pudieron cargar las opciones.');
    } finally {
      setLoading(false);
    }
  };

  const updateOptionRow = (index, field, value) => {
    setForm(f => {
      const options = [...f.options];
      options[index] = { ...options[index], [field]: value };
      return { ...f, options };
    });
  };

  const addOptionRow = () => {
    setForm(f => ({ ...f, options: [...f.options, { name: '', price_adjustment: '0' }] }));
  };

  const removeOptionRow = (index) => {
    setForm(f => ({ ...f, options: f.options.filter((_, i) => i !== index) }));
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const cleanOptions = form.options
      .filter(o => o.name.trim() !== '')
      .map(o => ({ name: o.name.trim(), price_adjustment: parseFloat(o.price_adjustment) || 0 }));

    if (cleanOptions.length === 0) {
      alert('Agrega al menos una opción (ej: "Con papas", "Sin papas")');
      return;
    }

    try {
      await api.post('/modifiers', {
        branch_id: 1,
        name: form.name,
        description: form.description || undefined,
        min_selections: parseInt(form.min_selections) || 0,
        max_selections: parseInt(form.max_selections) || 1,
        options: cleanOptions,
      });
      setForm(emptyForm());
      setShowForm(false);
      fetchModifiers();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al crear el grupo de opciones');
    }
  };

  const deleteGroup = async (id) => {
    if (!window.confirm('¿Eliminar este grupo de opciones? Se quitará de todos los productos que lo usen.')) return;
    try {
      await api.delete(`/modifiers/${id}`);
      fetchModifiers();
    } catch (err) {
      alert('Error al eliminar el grupo de opciones');
    }
  };

  if (loading) return <p style={{ color: '#94a3b8', textAlign: 'center', padding: 50 }}>Cargando opciones...</p>;

  if (error) return (
    <div>
      <h1 style={{ color: '#e2e8f0', fontSize: 28, marginBottom: 24 }}>⚙️ Opciones / Modificadores</h1>
      <div className="card" style={{ textAlign: 'center', padding: 40 }}>
        <p style={{ color: '#ef4444', marginBottom: 16 }}>{error}</p>
        <button onClick={fetchModifiers} className="btn btn-primary">Reintentar</button>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ color: '#e2e8f0', fontSize: 28 }}>⚙️ Opciones / Modificadores</h1>
        <button onClick={() => { setForm(emptyForm()); setShowForm(!showForm); }} className="btn btn-primary">
          {showForm ? 'Cancelar' : '+ Nuevo grupo de opciones'}
        </button>
      </div>
      <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20, maxWidth: 700 }}>
        Crea acá los grupos de opciones (ej: "Término de cocción", "Tipo de bebida"). Después, al crear o editar
        un plato en "Gestionar Menú", elige cuáles de estos grupos aplican a ese plato y qué opciones específicas
        ofrece.
      </p>

      {showForm && (
        <div className="card" style={{ marginBottom: 24 }}>
          <form onSubmit={submitForm}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 16 }}>
              <input type="text" placeholder="Nombre del grupo * (ej: Tipo de bebida)" className="input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
              <input type="text" placeholder="Descripción (opcional)" className="input" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
              <div>
                <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 6 }}>Selecciones mínimas (0 = opcional)</label>
                <input type="number" min="0" className="input" value={form.min_selections} onChange={e => setForm({...form, min_selections: e.target.value})} />
              </div>
              <div>
                <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 6 }}>Selecciones máximas (1 = elegir solo una)</label>
                <input type="number" min="1" className="input" value={form.max_selections} onChange={e => setForm({...form, max_selections: e.target.value})} />
              </div>
            </div>

            <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 8 }}>
              Opciones iniciales (después puedes agregar, editar o quitar más con "✏️ Editar")
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
              {form.options.map((opt, i) => (
                <div key={i} style={{ display: 'flex', gap: 8 }}>
                  <input
                    type="text"
                    placeholder="Nombre de la opción"
                    className="input"
                    style={{ flex: 1 }}
                    value={opt.name}
                    onChange={e => updateOptionRow(i, 'name', e.target.value)}
                  />
                  <input
                    type="number"
                    step="0.01"
                    placeholder="+/- precio"
                    className="input"
                    style={{ width: 120 }}
                    value={opt.price_adjustment}
                    onChange={e => updateOptionRow(i, 'price_adjustment', e.target.value)}
                  />
                  <button type="button" onClick={() => removeOptionRow(i)} style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: 'none', borderRadius: 8, width: 40, cursor: 'pointer' }}>✕</button>
                </div>
              ))}
            </div>
            <button type="button" onClick={addOptionRow} className="btn" style={{ background: '#334155', color: '#e2e8f0', marginBottom: 16 }}>
              + Agregar opción
            </button>

            <button type="submit" className="btn btn-success" style={{ width: '100%' }}>
              💾 Guardar grupo de opciones
            </button>
          </form>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {modifiers.map(mod => (
          <div key={mod.id} className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <h4 style={{ color: '#e2e8f0', fontSize: 15 }}>{mod.name}</h4>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => setEditTarget(mod)} style={{ background: 'rgba(56,189,248,0.1)', color: '#38bdf8', border: 'none', borderRadius: 6, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>✏️</button>
                <button onClick={() => deleteGroup(mod.id)} style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: 'none', borderRadius: 6, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>🗑️</button>
              </div>
            </div>
            {mod.description && <p style={{ color: '#64748b', fontSize: 12, marginBottom: 8 }}>{mod.description}</p>}
            <p style={{ color: '#94a3b8', fontSize: 11, marginBottom: 10 }}>
              Mín {mod.min_selections} · Máx {mod.max_selections}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {mod.options?.map(opt => (
                <div key={opt.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                  <span style={{ color: '#cbd5e1' }}>{opt.name}</span>
                  <span style={{ color: parseFloat(opt.price_adjustment) > 0 ? '#fbbf24' : '#64748b' }}>
                    {parseFloat(opt.price_adjustment) > 0 ? `+$${parseFloat(opt.price_adjustment).toFixed(2)}` : 'Incluido'}
                  </span>
                </div>
              ))}
              {(!mod.options || mod.options.length === 0) && (
                <p style={{ color: '#64748b', fontSize: 12 }}>Sin opciones — edítalo para agregar.</p>
              )}
            </div>
          </div>
        ))}
        {modifiers.length === 0 && (
          <p style={{ color: '#64748b', gridColumn: '1 / -1', textAlign: 'center', padding: 30 }}>
            Todavía no creaste ningún grupo de opciones.
          </p>
        )}
      </div>

      {editTarget && (
        <EditModifierModal
          modifier={editTarget}
          onClose={() => setEditTarget(null)}
          onSaved={fetchModifiers}
        />
      )}
    </div>
  );
};

export default ModifiersPage;